// =============================================================================
// AGENT 4 — STRATEG KONWERSJI: PANEL WYJAŚNIEŃ AI
// Konsumuje ExplanationPayload z Agent 3, prezentuje w UI.
// =============================================================================

import type { ExplanationPayload } from '../../engine/explanationBuilder';
import { COPY } from '../../copy/microcopy';

interface ExplanationPanelProps {
  payload: ExplanationPayload;
  taskTitles: Record<string, string>;
}

export function ExplanationPanel({ payload, taskTitles }: ExplanationPanelProps) {
  const correctCount = payload.verdictSummaries.filter((v) => v.isCorrect).length;

  const getVerdictLabel = (level: 1 | 2 | 3) => {
    if (level === 1) return COPY.results.verdictLevelOne;
    if (level === 2) return COPY.results.verdictLevelTwo;
    return COPY.results.verdictLevelThree;
  };

  const getVerdictClass = (level: 1 | 2 | 3) => {
    if (level === 1) return 'verdict-card--correct';
    if (level === 2) return 'verdict-card--partial';
    return 'verdict-card--wrong';
  };

  return (
    <details className="explanation-panel" aria-label="Analiza decyzji">
      <summary className="explanation-panel__summary">
        <div className="explanation-panel__summary-text">
          <span className="explanation-panel__title">Analiza decyzja po decyzji</span>
          <span className="explanation-panel__meta">
            {correctCount} z {payload.verdictSummaries.length} trafione · kliknij, aby rozwinąć
          </span>
        </div>
        <span className="explanation-panel__toggle" aria-hidden="true">Rozwiń</span>
      </summary>

      <div className="explanation-panel__content">
        {payload.verdictSummaries.map((v, index) => (
          <details
            key={v.taskId}
            className={`verdict-card ${getVerdictClass(v.decisionLevel)}`}
            open={v.decisionLevel > 1}
            style={{ '--delay': `${index * 100}ms` } as React.CSSProperties}
          >
            <summary className="verdict-card__summary">
              <div className="verdict-card__summary-header">
                <span className="verdict-card__task-title">
                  {taskTitles[v.taskId] ?? v.taskId}
                </span>
                <span className="verdict-card__label">
                  {getVerdictLabel(v.decisionLevel)}
                </span>
              </div>
              <div className="verdict-card__comparison">
                <div className="verdict-card__choice">
                  <span className="verdict-card__choice-label">Twój wybór:</span>
                  <span className="verdict-card__worker-name">👤 {v.playerWorkerName}</span>
                </div>
                <div className="verdict-card__choice">
                  <span className="verdict-card__choice-label">AI rekomendacja:</span>
                  <span className="verdict-card__worker-name">🤖 {v.aiWorkerName}</span>
                </div>
              </div>
            </summary>
            <div className="verdict-card__details">
              <div className="verdict-card__explanation">{v.explanation}</div>
            </div>
          </details>
        ))}
      </div>
    </details>
  );
}

